import TeamSection from '@/components/TeamSection';
import Footer from '@/components/Footer';

export default function AboutPage() {
  return (
    <div className="pt-20">
      <TeamSection />
      <Footer />
    </div>
  );
}
